import React, { useEffect } from 'react';

import PageContent from './PageContent';
import { PageConttainerViewModel as useViewModel } from './PageConttainerViewModel';
import PageHeader from './PageHeader';

export type PageContainerProps = {
  title: string;
  description?: string;
  backOnClick?: () => void;
  onOptionClick?: () => void;
  optionIcon?: string;
  optionPlaceHolder?: string;
  children: React.ReactNode;
};

const PageContainer: React.FunctionComponent<PageContainerProps> = (props) => {
  const { handleBack, firstRender } = useViewModel();

  useEffect(() => {
    firstRender();
  }, []);

  const backOnClickHandler = () => (props.backOnClick != undefined ? props.backOnClick() : handleBack());

  return (
    <>
      <PageHeader
        title={props.title}
        description={props.description}
        onBackClick={backOnClickHandler}
        onOptionClick={props.onOptionClick}
        optionIcon={props.optionIcon}
        optionPlaceHolder={props.optionPlaceHolder}
      />
      <PageContent>{props.children}</PageContent>
    </>
  );
};

export default PageContainer;
